const parseFlag = (
  value: string | undefined,
  defaultValue = false,
): boolean => {
  if (value === undefined) {
    return defaultValue;
  }
  return value.trim().toLowerCase() === "true";
};

export const voiceFeatureFlags = {
  voiceInputEnabled: parseFlag(import.meta.env.VITE_VOICE_INPUT_ENABLED, true),
  serverFallbackEnabled: parseFlag(
    import.meta.env.VITE_VOICE_SERVER_FALLBACK_ENABLED,
    true,
  ),
  maxRecordingDurationMs: Number(
    import.meta.env.VITE_VOICE_MAX_RECORDING_DURATION_MS ?? "90000",
  ),
} as const;
